import React from "react";

const BookmarkIcon = ({ color = "transparent", ...rest }) => {
  return (
    <svg {...rest} viewBox="0 0 24 24" stroke={color} stroke-width="2">
      <path
        fill="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
        {...rest}
      />
    </svg>
  );
};

export default BookmarkIcon;
